export default __webpack_public_path__ + "static/banner-auto-413c85b917057d425627ccd219f99c64.webp";